import React, { useCallback, useEffect, useRef, useState } from "react";
import TableChartIcon from "@mui/icons-material/TableChart";
import Chart from "chart.js/auto";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { Document, Packer, Paragraph, Table, TableCell, TableRow } from "docx";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { fetchSources } from "../../../../../store/slices/sourceSlice";
import { setSourceFromDateRedux, setSourceRedux, setSourceToDateRedux } from "../../../../../store/slices/filterSlice";
import { setFilteredReports } from "../../../../../store/slices/filteredDataSlice";
import { setFilteredNavData } from "../../../../../store/slices/LeadreportfilteredSlice";
import RemoveIcon from '@mui/icons-material/Remove';
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import DateConversion from "../../../../../utils/DateConversion";
import CommaConvert from "../../../../../utils/CommaConvert";


const LeadSourceL1 = ({ wrapperClasses }) => {
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
  const USAComma = CommaConvert();
  const [leadsourceDownload, setLeadSourceDownload] = useState([]);
  const navigate = useNavigate();

  const [filteredLeadReportsLead, setFilteredLeadReportsLead] = useState([]);
  const { filteredReports } = useSelector((state) => state.filteredData);
  const [showgraph, setShowgraph] = useState(true);

  const handleToggleTable = () => {
    setShowgraph(!showgraph);
  };
  useEffect(() => {
    if (filteredReports) {
      setFilteredLeadReportsLead(filteredReports);
    }
  }, [filteredReports]);

  useEffect(() => {
    dispatch(setFilteredReports());
  }, [dispatch]);

  useEffect(() => {
    if (filteredReports) {
      setLeadSourceDownload(filteredReports);
    }
  }, [filteredReports]);

  const [leadTab, setLeadTab] = useState("graph");
  const sourceChartRef = useRef(null);
  const sourcePieChart = useRef();

  const StatusdropdownRef = useRef(null);
  const [showsourseDropdown, setshowsourceDropdown] = useState(false);
  const [selectedSourcefinal] = useState("All");
  const [potentialSource, setPotentialSource] = useState([]);
  const [SourcesL1, setSourcesL1] = useState([]);

  const { source } = useSelector((state) => state.source);

  useEffect(() => {
    dispatch(fetchSources())
  }, [dispatch])

  useEffect(() => {
    if (source.length > 0) {
      setSourcesL1(source);
    }
  }, [source]);

  const [sourceFilterDateFrom, setSourceFilterDateFrom] = useState();
  const [sourceFilterDateTo, setSourceFilterDateTo] = useState();
  const [selectedSource, setSelectedSource] = useState("All");

  const handleSourceDateFrom = (date) => {
    if (!date) return;
    setSourceFilterDateFrom(date);
    dispatch(setSourceFromDateRedux(date))
  }
  const handleSourceDateTo = (date) => {
    if (!date) return;
    setSourceFilterDateTo(date);
    dispatch(setSourceToDateRedux(date))
  }
  const handleSource = (source) => {
    if (!source) return;
    setSelectedSource(source)
    dispatch(setSourceRedux(source))
    setshowsourceDropdown(false); // Close dropdown on selection
  }

  const sourceFilterDateFromRedux = useSelector((state) => state.filters.sourceFilterDateFrom);
  const sourceFilterDateToRedux = useSelector((state) => state.filters.sourceFilterToDate);
  const sourceFilterRedux = useSelector((state) => state.filters.sourceFilter);

  useEffect(() => {
    if (sourceFilterDateFromRedux !== undefined && sourceFilterDateFromRedux !== null) {
      setSourceFilterDateFrom(sourceFilterDateFromRedux)
    } else { setSourceFilterDateFrom("") }
  }, [sourceFilterDateFromRedux])

  useEffect(() => {
    if (sourceFilterDateToRedux !== undefined && sourceFilterDateToRedux !== null) {
      setSourceFilterDateTo(sourceFilterDateToRedux)
    } else { setSourceFilterDateTo("") }
  }, [sourceFilterDateToRedux])
  useEffect(() => {
    if (sourceFilterRedux !== undefined && sourceFilterRedux !== null) {
      setSelectedSource(sourceFilterRedux)
    } else { setSelectedSource("All") }
  }, [sourceFilterRedux])

  // Handle clicks outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        StatusdropdownRef.current &&
        !StatusdropdownRef.current.contains(event.target)
      ) {
        setshowsourceDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDownload = (event) => {
    const value = event.target.value;

    if (value === "pdf") {
      downloadPDF();
    } else if (value === "word") {
      downloadWord();
    } else if (value === "excel") {
      downloadExcel();
    }
    setIsDropdownVisible(false);
  };

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible); // Toggle dropdown visibility
  };

  const downloadExcel = () => {
    const sortedLeads = [...leadsourceDownload].sort(
      (a, b) => new Date(a.LeadDate) - new Date(b.LeadDate)
    );

    const ws = XLSX.utils.json_to_sheet(
      sortedLeads.map((LeadReport, index) => ({
        "Sr.No": index + 1,
        "Lead Date": LeadReport.LeadDate
          ? formatDateByCountry(LeadReport.LeadDate)
          : " ",
        "Client Name": LeadReport.ClientName,
        "Project Name": LeadReport.ProjectName,
        "Lead Type": LeadReport.LeadType,
        "Quoted Value": USAComma(LeadReport.QuotedValue), // ✅ Ensure it's a number
        Source: LeadReport.Source,
        Status: LeadReport.Status,
        Group: LeadReport.AssignedGroup,
        "Follow-up Date":
          LeadReport.Status === "Won" || LeadReport.Status === "Lost"
            ? " "
            : formatDateByCountry(LeadReport.FollowupDate),
      }))
    );

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Lead Reports");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelFile = new Blob([excelBuffer], {
      bookType: "xlsx",
      type: "application/octet-stream",
    });
    saveAs(excelFile, "LeadReports.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [
        [
          "Sr.No",
          "Lead Date",
          "Client Name",
          "Project Name",
          "Lead Type",
          "Quoted Value",
          "Source",
          "Status",
          "Group",
          "Follow-up Date",
        ],
      ],
      body: leadsourceDownload.map((LeadReport, index) => [
        index + 1,
        LeadReport.LeadDate ? formatDateByCountry(LeadReport.LeadDate) : " ",
        LeadReport.ClientName,
        LeadReport.ProjectName,
        LeadReport.LeadType,
        `${currency}${USAComma(LeadReport.QuotedValue)}`,
        LeadReport.Source,
        LeadReport.Status,
        LeadReport.AssignedGroup,
        LeadReport.Status === "Won" || LeadReport.Status === "Lost"
          ? " "
          : formatDateByCountry(LeadReport.FollowupDate),
      ]),
      styles: {
        fontSize: 7,
      },
      headStyles: {
        fontSize: 8,
      },
    });
    doc.save("LeadReports.pdf");
  };

  const downloadWord = () => {
    const headerRow = new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph("Sr.No")],
        }),
        new TableCell({
          children: [new Paragraph("Lead Date")],
        }),
        new TableCell({
          children: [new Paragraph("Client Name")],
        }),
        new TableCell({
          children: [new Paragraph("Project Name")],
        }),
        new TableCell({
          children: [new Paragraph("Lead Type")],
        }),
        new TableCell({
          children: [new Paragraph("Quoted Value")],
        }),
        new TableCell({
          children: [new Paragraph("Source")],
        }),
        new TableCell({
          children: [new Paragraph("Status")],
        }),
        new TableCell({
          children: [new Paragraph("Group")],
        }),
        new TableCell({
          children: [new Paragraph("Follow-up Date")],
        }),
      ],
    });

    const dataRows = leadsourceDownload.map((LeadReport, index) => {
      return new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph(`${index + 1}`)],
          }),
          new TableCell({
            children: [
              new Paragraph(
                LeadReport.LeadDate ? formatDateByCountry(LeadReport.LeadDate) : " "
              ),
            ],
          }),
          new TableCell({
            children: [new Paragraph(LeadReport.ClientName)],
          }),
          new TableCell({
            children: [new Paragraph(LeadReport.ProjectName)],
          }),
          new TableCell({
            children: [new Paragraph(LeadReport.LeadType)],
          }),
          new TableCell({
            children: [
              new Paragraph(
                `${currency}${USAComma(LeadReport.QuotedValue)}`
              ),
            ],
          }),
          new TableCell({
            children: [new Paragraph(LeadReport.Source)],
          }),
          new TableCell({
            children: [new Paragraph(LeadReport.Status)],
          }),
          new TableCell({
            children: [new Paragraph(LeadReport.AssignedGroup)],
          }),
          new TableCell({
            children: [
              new Paragraph(
                LeadReport.Status === "Won" || LeadReport.Status === "Lost"
                  ? " "
                  : formatDateByCountry(LeadReport.FollowupDate)
              ),
            ],
          }),
        ],
      });
    });

    const doc = new Document({
      sections: [
        {
          properties: {},
          children: [
            new Table({
              rows: [headerRow, ...dataRows],
            }),
          ],
        },
      ],
    });

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, "LeadReports.docx");
    });
  };

  const popupRef = useRef(null);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsDropdownVisible(false); // Close the popup if clicked outside
    }
  };
  useEffect(() => {
    if (isDropdownVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownVisible]);



  const [totalSourceAmount, setTotalSourceAmount] = useState(0);
  const [totalPercentage, setTotalPercentage] = useState(0);
  const [totalGraphCount, setTotalGraphCount] = useState(0);
  const [totalSourcCount, setTotalSourcCount] = useState(0);

  const aggregateLeadSourceData = useCallback(
    (filteredData) => {
      if (filteredLeadReportsLead.length === 0) {
        return;
      }

      const totalSourceAmount = filteredData.reduce(
        (sum, lead) => sum + (lead.QuotedValue || 0),
        0
      );
      const totalSourceCount = filteredLeadReportsLead.length;
      setTotalGraphCount(totalSourceCount);
      const totalCalculatedCount = filteredData.length;

      const groupedData = filteredData.reduce((acc, lead) => {
        const source = lead.Source; // Assuming each lead has a status property
        if (!acc[source]) {
          acc[source] = [];
        }
        acc[source].push(lead);
        return acc;
      }, {});

      const sourceData = Object.keys(groupedData).map((source) => {
        const leadsForSource = groupedData[source];

        const totalQuotedAmount = leadsForSource.reduce(
          (sum, lead) => sum + (lead.QuotedValue || 0),
          0
        );
        const count = leadsForSource.length;
        const percentage = ((count / totalSourceCount) * 100).toFixed(2);

        return {
          amount: totalQuotedAmount,
          count,
          percentage,
          source,
        };
      });
      const totalPercentage = sourceData
        .reduce((sum, source) => sum + parseFloat(source.percentage), 0)
        .toFixed(2);

      setTotalPercentage(totalPercentage);
      setPotentialSource(sourceData);
      setTotalSourceAmount(totalSourceAmount);
      setTotalSourcCount(totalCalculatedCount);
    },
    [
      filteredLeadReportsLead,
      // filteredLeadReports,
      setPotentialSource,
      setTotalSourceAmount,
    ]
  );

  // useEffect(() => {
  //   setFilteredLeadReportsLead(filteredLeadReports);

  // }, [filteredLeadReports]);

  useEffect(() => {
    if (filteredLeadReportsLead) {
      aggregateLeadSourceData(filteredLeadReportsLead);
    }
  }, [aggregateLeadSourceData, filteredLeadReportsLead]);

  const handleLeadingSourceFilter = () => {
    // Filter data based on date range and status selection
    const filteredData = filteredLeadReportsLead.filter((item) => {
      const itemDate = new Date(item.LeadDate);
      const isWithinDateRange =
        (!sourceFilterDateFrom || itemDate >= sourceFilterDateFrom) &&
        (!sourceFilterDateTo || itemDate <= sourceFilterDateTo);

      const isMatchingSource =
        !selectedSource ||
        selectedSource === "All" ||
        item.Source === selectedSource;
      return isWithinDateRange && isMatchingSource;
    });
    // Store the sorted data for the chart
    setPotentialSource(filteredData);
    aggregateLeadSourceData(filteredData);
    setLeadSourceDownload(filteredData);
  };

  const leadSourceNavigationl1 = useCallback(
    (clickedSource) => {
      const filteredDataLeadSourcel1 = leadsourceDownload.filter(
        (item) => item.Source === clickedSource
      );
      dispatch(setFilteredNavData(filteredDataLeadSourcel1));
      navigate(`/dashboard/lead-report`);
    },
    [leadsourceDownload, navigate, dispatch]
  );

  // useEffect(() => {
  //   const renderSourceChart = () => {
  //     if (potentialSource.length > 0 && leadTab === "graph") {
  //       const ctxSource = sourcePieChart.current;
  //       if (sourceChartRef.current) {
  //         sourceChartRef.current.destroy();
  //       }

  //       const customLabelPlugin = {
  //         id: "customLabelPlugin",
  //         afterDatasetsDraw(chart) {
  //           const { ctx, data } = chart;
  //           ctx.save();
  //           ctx.font = "bold 14px Arial";
  //           ctx.textAlign = "center";
  //           ctx.textBaseline = "middle";

  //           data.datasets.forEach((dataset, datasetIndex) => {
  //             dataset.data.forEach((value, index) => {
  //               if (value === "" || value === 0) return;
  //               const meta = chart.getDatasetMeta(datasetIndex);
  //               const bar = meta.data[index];

  //               if (bar) {
  //                 const { x, y, base } = bar.tooltipPosition();
  //                 const barHeight = base - y;
  //                 const padding = 6;
  //                 const adjustedY = y - padding;
  //                 const percentage = Number(value);
  //                 ctx.fillStyle = barHeight > 30 ? "white" : "black";
  //                 // ctx.fillText(percentage, x, adjustedY);
  //                 if (percentage !== 0) {
  //                   ctx.fillText(`${percentage}%`, x, adjustedY);
  //                 }
  //               }
  //             });
  //           });

  //           ctx.restore();
  //         },
  //       };

  //       // Prepare data for all sources
  //       const orderedData = SourcesL1.map((source) => {
  //         const item = potentialSource.find(
  //           (p) => p.source === source.newSource
  //         );
  //         return {
  //           source: source.newSource,
  //           count: item ? item.count : 0,
  //         };
  //       });

  //       // Fix: Ensure all bars have values by default
  //       const filteredData = orderedData.map((item) => {
  //         if (selectedSourcefinal === "All") {
  //           return ((item.count / totalGraphCount) * 100).toFixed(2); // Show all values
  //         } else {
  //           return item.source === selectedSourcefinal
  //             ? ((item.count / totalGraphCount) * 100).toFixed(2) // Show selected source
  //             : ""; // Keep others visible but empty
  //         }
  //       });

  //       sourceChartRef.current = new Chart(ctxSource, {
  //         type: "bar",
  //         data: {
  //           labels: orderedData.map((item) => item.source),

  //           datasets: [
  //             {
  //               label: "Percentage",
  //               borderRadius: 8,
  //               data: filteredData,
  //               backgroundColor: ["#15803d", "#89AC46", "orange", "#DC2626"],
  //             },
  //           ],
  //         },
  //         options: {
  //           responsive: true,
  //           maintainAspectRatio: false,
  //           plugins: {
  //             legend: { display: false },
  //             tooltip: { enabled: false },
  //           },
  //           onClick: (event, elements) => {
  //             if (elements.length > 0) {
  //               const clickedElementIndex = elements[0].index;
  //               const clickedSource = orderedData[clickedElementIndex].source;
  //               leadSourceNavigationl1(clickedSource);
  //             }
  //           },
  //           scales: {
  //             x: {
  //               border: {
  //                 color: "black", //
  //               },
  //               grid: {
  //                 display: false,
  //                 border: {
  //                   color: "black",
  //                 },
  //               },
  //               ticks: {
  //                 color: "black",
  //                 font: {
  //                   size: 14,
  //                   weight: "bold",
  //                 },
  //               },
  //             },
  //             y: {
  //               display: false,
  //               grid: { display: false },
  //               ticks: { display: false },
  //               suggestedMin: 0,
  //               suggestedMax:
  //                 Math.max(...filteredData.map((v) => parseFloat(v))) + 10, // Adjust for better scaling
  //             },
  //           },
  //         },
  //         plugins: [customLabelPlugin],
  //       });
  //     }
  //   };
  //   renderSourceChart();
  // }, [
  //   leadTab,
  //   potentialSource,
  //   selectedSourcefinal,
  //   SourcesL1,
  //   totalGraphCount,
  //   leadSourceNavigationl1,
  //   showgraph
  // ]);

  const renderSourceChart = useCallback(() => {
    // Only proceed if potentialSource has data and we're in graph mode
    if (potentialSource.length > 0 && leadTab === "graph" && sourcePieChart.current) {
      const ctxSource = sourcePieChart.current.getContext("2d");

      // Destroy the previous chart if it exists
      if (sourceChartRef.current) {
        sourceChartRef.current.destroy();
      }

      // Define the custom label plugin
      const customLabelPlugin = {
        id: "customLabelPlugin",
        afterDatasetsDraw(chart) {
          const { ctx, data } = chart;
          ctx.save();
          ctx.font = "bold 14px Arial";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";

          data.datasets.forEach((dataset, datasetIndex) => {
            dataset.data.forEach((value, index) => {
              if (value === "" || value === 0) return;
              const meta = chart.getDatasetMeta(datasetIndex);
              const bar = meta.data[index];

              if (bar) {
                const { x, y, base } = bar.tooltipPosition();
                const barHeight = base - y;
                const padding = 6;
                const adjustedY = y - padding;
                const percentage = Number(value);
                ctx.fillStyle = barHeight > 30 ? "white" : "black";
                if (percentage !== 0) {
                  ctx.fillText(`${percentage}%`, x, adjustedY);
                }
              }
            });
          });

          ctx.restore();
        },
      };

      // Prepare data for all sources
      const orderedData = SourcesL1.map((source) => {
        const item = potentialSource.find((p) => p.source === source.newSource);
        return {
          source: source.newSource,
          count: item ? item.count : 0,
        };
      });

      // Ensure all bars have values by default
      const filteredData = orderedData.map((item) => {
        if (selectedSourcefinal === "All") {
          return ((item.count / totalGraphCount) * 100).toFixed(2);
        } else {
          return item.source === selectedSourcefinal
            ? ((item.count / totalGraphCount) * 100).toFixed(2)
            : "";
        }
      });

      // Create the new chart
      sourceChartRef.current = new Chart(ctxSource, {
        type: "bar",
        data: {
          labels: orderedData.map((item) => item.source),
          datasets: [
            {
              label: "Percentage",
              borderRadius: 8,
              data: filteredData,
              backgroundColor: ["#15803d", "#89AC46", "orange", "#DC2626"],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
          },
          onClick: (event, elements) => {
            if (elements.length > 0) {
              const clickedElementIndex = elements[0].index;
              const clickedSource = orderedData[clickedElementIndex].source;
              leadSourceNavigationl1(clickedSource);
            }
          },
          scales: {
            x: {
              border: { color: "black" },
              grid: { display: false, border: { color: "black" } },
              ticks: {
                color: "black",
                font: { size: 14, weight: "bold" },
              },
            },
            y: {
              display: false,
              grid: { display: false },
              ticks: { display: false },
              suggestedMin: 0,
              suggestedMax: Math.max(...filteredData.map((v) => parseFloat(v))) + 10,
            },
          },
        },
        plugins: [customLabelPlugin],
      });
    }
  }, [
    potentialSource,
    leadTab,
    sourcePieChart,
    sourceChartRef,
    SourcesL1,
    selectedSourcefinal,
    totalGraphCount,
    leadSourceNavigationl1,
  ]);

  useEffect(() => {
    renderSourceChart();

    return () => {
      if (sourceChartRef.current) {
        sourceChartRef.current.destroy();
      }
    };
  }, [renderSourceChart, showgraph]);
  
  return (
    <div className=" rounded-lg w-full h-full justify-center font-semibold"
      Style={{ fontFamily: "Lora", fontWeight: 600 }}>
      <div className="min-h-[10%] px-3 rounded-md bg-white">
        <div className="flex flex-wrap  items-center justify-between md:gap-x-2 md:flex-nowrap xl:flex xl:justify-between">
          <div className="flex gap-2 px-1">
            <h1 className="text-2xl font-semibold sm:text-sm md:text-sm lg:text-xl">
              LEAD SOURCE
            </h1>

          </div>
          <div className="flex lg:ml-32  lg:items-center lg:justify-end ">
            <div className="flex justify-center items-center show-potential-download">
              <div className="show-potential-download lg:justify-end  ">
                <div className=" inline-block relative px-3 mt-1">
                  <div ref={popupRef} className={`flex items-center text-4xl sm:text-md md:text-xl lg:text-xl xl:text-2xl 2xl:text-4xl ${potentialSource.length === 0 ? 'opacity-50 pointer-events-none' : ''}`}>
                    <CloudDownloadIcon
                      onClick={toggleDropdown}
                      className="cursor-pointer"
                    // fontSize="4rem"
                    />

                    {isDropdownVisible && (
                      <div

                        className="absolute top-8 -left-0 shadow-lg z-50 bg-white text-base"
                      >
                        <div
                          className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                          onClick={() =>
                            handleDownload({ target: { value: "pdf" } })
                          }
                        >
                          PDF
                        </div>
                        <div
                          className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                          onClick={() =>
                            handleDownload({ target: { value: "excel" } })
                          }
                        >
                          Excel
                        </div>
                        <div
                          className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                          onClick={() =>
                            handleDownload({ target: { value: "word" } })
                          }
                        >
                          Word
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between text-3xl sm:text-xl md:text-md">
                {leadTab === "table" && (
                  <span title="Graph">
                    <SignalCellularAltIcon
                      className="cursor-pointer"
                      onClick={() => setLeadTab("graph")}
                    // fontSize="3rem"
                    />
                  </span>
                )}
                {leadTab === "graph" && (
                  <span title="Table">
                    <TableChartIcon
                      className="cursor-pointer"
                      onClick={() => setLeadTab("table")}
                    // fontSize="3rem"
                    />
                  </span>
                )}
              </div>
              <div onClick={() => handleToggleTable()}
                className=" ml-4 mt-1 flex justify-center items-center border rounded-md w-6 h-6 cursor-pointer" >
                <RemoveIcon
                  className=" cursor-pointer"
                />
              </div>
            </div>
          </div>
        </div>
        <hr />
        <hr />
      </div>

      {showgraph && (
        <div className="h-[23.5rem] ">
          <div className="bg-white px-3 flex gap-3 items-center w-full justify-between pt-1 lg:flex-nowrap lg:gap-2">
            <div className="flex justify-between align-middle items-center w-full gap-1">
              <div className="w-[25%] flex align-middle p-1 border border-[#e3eaff] rounded-md ">
                <div className="pl-1 pt-1.5 text-xs font-semibold">
                  <p>From-</p>
                </div>
                <div className="h-full w-full ">
                  <DatePicker
                    selected={sourceFilterDateFrom}
                    onChange={handleSourceDateFrom}
                    dateFormat={getDateFormat()}
                    className=" w-full h-full text-xs  m-0  outline-none date-picker-placeholder"
                    placeholderText={getDatePlaceholder()}
                    required
                  />
                </div>
              </div>
              |
              <div className="w-[25%] flex align-middle p-1 border border-[#e3eaff] rounded-md ">
                <div className=" pl-1 pt-1.5 text-xs font-semibold">
                  <p>To-</p>
                </div>
                <div className="h-full w-full ">
                  <DatePicker
                    selected={sourceFilterDateTo}
                    onChange={handleSourceDateTo}
                    dateFormat={getDateFormat()}
                    className=" w-full h-full text-xs m-0  outline-none date-picker-placeholder"
                    placeholderText={getDatePlaceholder()}
                    required
                    minDate={
                      sourceFilterDateFrom
                        ? new Date(sourceFilterDateFrom.getTime() + 86400000)
                        : null
                    }
                  />
                </div>
              </div>
              <div className="relative flex align-middle items-center w-[25%]">

                <div className="absolute cursor-pointer right-0 border-r border-[#e3eaff] bg-white z-20">
                  <ExpandMoreIcon
                    color="white"
                    className=""
                    onClick={() => setshowsourceDropdown(!showsourseDropdown)}
                  />
                </div>
                <div
                  ref={StatusdropdownRef}
                  className="relative border w-full border-[#e3eaff]  rounded-md"
                >
                  <button
                    type="button"
                    onClick={() => setshowsourceDropdown(!showsourseDropdown)}
                    className=" flex justify-start items-center align-middle w-full h-full p-2 text-nowrap truncate focus:outline-none text-xs"
                  >
                    {selectedSource}
                  </button>

                  {showsourseDropdown && (
                    <div className="absolute font-semibold flex flex-col w-28 p-0.5 gap-2 z-50  bg-white text-xs border border-gray-300 overflow-y-auto shadow-lg max-h-48  mt-0.5">
                      <label
                        htmlFor="All"
                        className="p-1 hover:bg-gray-300 font-semibold"
                        onClick={() => {
                          setSelectedSource("All");
                          // setshowsourceDropdown(false); // Close dropdown on selection
                        }}
                      >
                        All
                      </label>

                      {SourcesL1.map((Sourc) => (
                        <label
                          onClick={() => {
                            handleSource(Sourc.newSource);
                          }}
                          key={Sourc.id}
                          value={Sourc.newSource}
                          className="p-1 hover:bg-gray-300"
                        >
                          {Sourc.newSource}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="w-[25%] flex justify-end">
                <button
                  className="text-white bg-[#e32278] p-2 px-4 text-xs rounded-md max-w-24 shadow-md"
                  onClick={handleLeadingSourceFilter}
                >
                  SUBMIT
                </button>
              </div>
            </div>
          </div>
          <div className="h-[21rem] flex bg-white px-3 pb-2 rounded-b-md">
            {leadTab === "table" ? (
              potentialSource.length > 0 ? (
                <div className="w-full pt-3">
                  <div className=" max-h-[18rem] overflow-scroll">
                    <table className="w-full divide-y divide-gray-200">
                      <thead className="bg-black sticky top-0">
                        <tr className="text-white">
                          <th className="px-3 py-2 text-left border text-sm font-medium  capitalize tracking-wider">
                            Source
                          </th>
                          <th className="px-3 py-2 text-center border text-sm font-medium capitalize tracking-wider">
                            Count
                          </th>
                          <th className="px-3 py-2 text-center border text-sm font-medium capitalize tracking-wider">
                            %
                          </th>
                          <th className="px-3 py-2 text-right border text-sm font-medium capitalize tracking-wider">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {potentialSource.map((item, index) => (
                          <tr className="border text-[16px]" key={index}>
                            <td
                              onClick={() => leadSourceNavigationl1(item.source)}
                              style={{ cursor: "pointer" }}
                              className="px-2 text-left py-2 font-thin"
                            >
                              {item.source.toUpperCase()}
                            </td>
                            <td className="px-2 text-center py-1">{item.count}</td>
                            <td className="px-2 text-center py-1">
                              {item.percentage} %
                            </td>
                            <td className="px-2 text-right py-1">
                              {currency}
                              {USAComma(item.amount)}
                            </td>
                          </tr>
                        ))}
                        {/* Display total row */}

                        <tr className="border bg-gray-200 font-bold text-md">
                          <td className="px-3 text-left py-2">TOTAL :</td>
                          <td className="px-3 text-center py-2">
                            {totalSourcCount}
                          </td>
                          <td className="px-3 text-center py-2">
                            {totalPercentage === "99.99" ? 100 : totalPercentage}%
                          </td>{" "}
                          <td className="px-3 text-right py-2">
                            {" "}
                            {currency}
                            {USAComma(totalSourceAmount)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="flex justify-center align-middle items-center text-center  w-full">
                  <p className="noDataAvailable ">
                    No data available
                  </p> </div>
              )
            ) : potentialSource.length > 0 ? (
              <canvas
                id="sourcePieChart"
                ref={sourcePieChart}
                width="300"
                height="300"
                className=""
              ></canvas>
            ) : (
              <div className="flex justify-center align-middle items-center text-center  w-full">
                <p className="noDataAvailable">
                  No data available
                </p> </div>
            )}
          </div>
        </div>
      )}

    </div>
  );
};

export default LeadSourceL1;
